import { Component, Prop, Watch } from 'vue-property-decorator'
import ClvrComponent from '../../../../../system/vue/Core/ClvrComponent'
import { KhText, KhSwitch, EmitEvents } from '@internal-libraries/kheops-ui-lib'
import { ClvrScreenControlHeadersInterface } from '../../ClvrScreenControlPlanningTable/interface'
import { ScreenControlDataTypeData } from '../../../Types/ScreenControlDataTypeData'

@Component({
    components: {
        KhText,
        KhSwitch,
        //@TODO tempo comment until KhList's call work
        //KhList,
    },
})
export default class ClvrScreenControlTemplateListDraggable extends ClvrComponent {
    @Prop({ type: Array, default: () => [] })
    public value!: ClvrScreenControlHeadersInterface[]
    @Prop({ type: String, default: ClvrScreenControlTemplateListDraggable.DEFAULT_CLASS_ITEM })
    public classItem!: string

    public static readonly DEFAULT_CLASS_ITEM = 'd-flex item align-center justify-content-between'
    public static readonly CLASS_ACTIVATED = 'screen-control-table-primary-color'
    public static readonly CLASS_DEACTIVATED = 'deactivated'

    public activateData: Record<string, boolean> = {}
    public activeGroup: Record<string, boolean> = {}
    public localItems: ScreenControlDataTypeData[] = []
    public isDragging = false
    public onGroupChange(item: ScreenControlDataTypeData, value: boolean): void {
        if (item.id) {
            this.activeGroup[item.id] = value
        }
    }

    @Watch('value', { immediate: true })
    private onItemPropChange(value: ScreenControlDataTypeData[]): void {
        this.localItems = value
        this.localItems
            .flatMap(({ dataTypeChildren = [], ...item }) => [item, ...dataTypeChildren])
            .forEach(header => {
                if (header.id) {
                    this.activateData[header.id] = header.enable || false
                }
            })
    }

    public getValue(id: number): boolean {
        return this.activeGroup[id]
    }

    public onSwitchChange(checked: boolean, header: ScreenControlDataTypeData): void {
        if (!header.id) return
        this.activateData[header.id] = checked
        this.$emit(
            EmitEvents.CHANGE,
            this.localItems.map(item => ({
                ...item,
                dataTypeChildren: item.dataTypeChildren?.map(child => {
                    return { ...child, enable: child.id ? !!this.activateData[child.id] : false }
                }),
                enable: item.id ? !!this.activateData[item.id] : false,
            })),
        )
    }

    public getActivatedClass(item: ClvrScreenControlHeadersInterface): string {
        return item.enable
            ? ClvrScreenControlTemplateListDraggable.CLASS_ACTIVATED
            : ClvrScreenControlTemplateListDraggable.CLASS_DEACTIVATED
    }

    public onOrderChange(headers: ClvrScreenControlHeadersInterface[]): void {
        this.$emit(EmitEvents.CHANGE, headers)
    }

    public dragStart(): void {
        this.isDragging = true
    }

    public dragEnd(): void {
        this.isDragging = false
    }
}
